import React, { createContext, useState, useMemo, useCallback , useEffect} from 'react';

import PropTypes from 'prop-types';
import { fetchIPAddress, handleAllowLocation, usePersistedState } from '../utils/Common';


export const GeographyContext = createContext();


export const GeographyProvider = ({ children }) => {
  const [stateOptions, setStateOptions] = usePersistedState('stateOptions',[]);
  const [isIPLocationReady, setIsIpLocationReady] = useState(false);
  
  const [ipAddress, setIPAddress] = usePersistedState('ipAddress', '50.77.48.17');
  const [location, setLocation] = usePersistedState('location',undefined);
  const [country,setCountry] = usePersistedState('country','USA');
  const currencies = useMemo(() => ([
    { currencyName: "USD", symbol: "$", unit: "lbs", country: "UNITED STATES" },
    { currencyName: "USD", symbol: "$", unit: "lbs", country: "US" },
    { currencyName: "AUD", symbol: "A$", unit: "kg", country: "AUSTRALIA" },
    { currencyName: "AUD", symbol: "A$", unit: "kg", country: "AUS" },
    { currencyName: "INR", symbol: "₹", unit: "kg", country: "INDIA" },
    { currencyName: "SGD", symbol: "S$", unit: "kg", country: "SINGAPORE" },
    { currencyName: "GBP", symbol: "£", unit: "kg", country: "UNITED KINGDOM" },
    { currencyName: "ZAR", symbol: "R", unit: "kg", country: "SOUTH AFRICA" },
    { currencyName: "MYR", symbol: "RM", unit: "kg", country: "MALAYSIA" },
    { currencyName: "AED", symbol: "د.إ", unit: "kg", country: "DUBAI" },
    { currencyName: "EUR", symbol: "€", unit: "kg", country: "IRELAND" },
    { currencyName: "EUR", symbol: "€", unit: "kg", country: "FRANCE" }
  ]), []);
  
  // Convert the currency data into the format MDBSelect expects
  const currencyOptions = currencies.map(currency => ({
      text: `${currency.country} (${currency.symbol})`
  }));
  useEffect(() => {
    const initializeApp = async () => {
      await handleAllowLocation(setLocation, ipAddress, setIPAddress);
      await fetchIPAddress(setIPAddress);     
      setIsIpLocationReady(true);
    };

    initializeApp();
  }, [ipAddress, setIPAddress, setLocation]);
  const clearCartState = useCallback(() => {
    setIPAddress(undefined);  
    setLocation(undefined);
    setCountry(undefined);
    setStateOptions([]);
    setIsIpLocationReady(false);
    localStorage.removeItem("ipAddress");
    localStorage.removeItem("location");
    localStorage.removeItem("country");
  }, [setCountry, setIPAddress, setLocation, setStateOptions]);

  const value = useMemo(() => ({
   ipAddress,country,location,clearCartState,currencyOptions,currencies,setCountry,setLocation,setIPAddress,stateOptions , setStateOptions
  }), [ipAddress, country, location, clearCartState, currencyOptions, currencies, setCountry, setLocation, setIPAddress,stateOptions , setStateOptions]);
 
  
  return (
    <GeographyContext.Provider value={value}>
      {children}
    </GeographyContext.Provider>
  );
};
GeographyProvider.propTypes = {
 children: PropTypes.node,
  };
  
  